const h1Base = {
	fontSize: '40px',
	lineHeight: '60px',
};
const h2Base = {
	fontSize: '32px',
	lineHeight: '48px',
};
const h3Base = {
	fontSize: '24px',
	lineHeight: '36px',
};
const h4Base = {
	fontSize: '20px',
	lineHeight: '30px',
};

const smallBase = {
	fontSize: '12px',
	lineHeight: '16px',
};
const mediumBase = {
	fontSize: '14px',
	lineHeight: '20px',
};
const largeBase = {
	fontSize: '16px',
	lineHeight: '24px',
};
const xLargeBase = {
	fontSize: '18px',
	lineHeight: '27px',
};
const xxLargeBase = {
	fontSize: '20px',
	lineHeight: '30px',
};

export const refineFonts = {
	//Headings
	h1Regular: {
		...h1Base,
		fontWeight: '400',
	},
	h1Bold: {
		...h1Base,
		fontWeight: '600',
	},
	h2Regular: {
		...h2Base,
		fontWeight: '400',
	},
	h2Bold: {
		...h2Base,
		fontWeight: '600',
	},
	h3Regular: {
		...h3Base,
		fontWeight: '400',
	},
	h3Bold: {
		...h3Base,
		fontWeight: '600',
	},
	h4Regular: {
		...h4Base,
		fontWeight: '400',
	},
	h4Bold: {
		...h4Base,
		fontWeight: '600',
	},
	//Body
	smallRegular: {
		...smallBase,
		fontWeight: '400',
	},
	smallBold: {
		...smallBase,
		fontWeight: '600',
	},
	mediumRegular: {
		...mediumBase,
		fontWeight: '400',
	},
	mediumBold: {
		...mediumBase,
		fontWeight: '600',
	},
	largeRegular: {
		...largeBase,
		fontWeight: '400',
	},
	largeBold: {
		...largeBase,
		fontWeight: '600',
	},
	xLargeRegular: {
		...xLargeBase,
		fontWeight: '400',
	},
	xLargeBold: {
		...xLargeBase,
		fontWeight: '600',
	},
	xxLargeRegular: {
		...xxLargeBase,
		fontWeight: '400',
	},
	xxLargeBold: {
		...xxLargeBase,
		fontWeight: '600',
	},
};
